import { FormActionsMui } from '@app/components/form/FormActionsMui';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { Grid } from '@mui/material';
import { useMemo } from 'react';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { z } from 'zod';
import { BaseSettingsFormProps } from '../../hooks/useSocialExportFactory';
import { FormSection } from '../../screens/manage/platforms/FormSection';

const minMsg = {
  id: 'validation.minValueZero',
  defaultMessage: 'Must be greater than or equal to 0',
};
const maxMsg = {
  id: 'validation.maxValue60000',
  defaultMessage: 'Must be less than or equal to 60000',
};

export function getDemoSettingsSchema(t: (msg: { id: string; defaultMessage: string }) => string) {
  return z.object({
    publishDelayMs: z.number().min(0, t(minMsg)).max(60000, t(maxMsg)).nullable().optional(),
    deleteDelayMs: z.number().min(0, t(minMsg)).max(60000, t(maxMsg)).nullable().optional(),
  });
}

/** @deprecated Use getDemoSettingsSchema(t) for translated messages */
export const demoSettingsSchema = getDemoSettingsSchema((msg) => msg.defaultMessage);

export function DemoSettingsForm({
  stationId,
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<socialExport.DemoSettingsDto>) {
  const { $t } = useIntl();
  const schema = useMemo(() => getDemoSettingsSchema((msg) => $t(msg)), [$t]);
  return (
    <FormContainer
      values={{
        publishDelayMs: defaultSettings?.publishDelayMs ?? 10000,
        deleteDelayMs: defaultSettings?.deleteDelayMs ?? 2000,
      }}
      onSuccess={async (formData) => {
        await onUpdate({
          publishDelayMs: formData.publishDelayMs ?? null,
          deleteDelayMs: formData.deleteDelayMs ?? null,
        });
      }}
      resolver={zodResolver(schema)}
    >
      <FormSection
        title={$t({
          id: 'socialExport.form.demoConfig',
          defaultMessage: 'Configuración de Demo',
        })}
      >
        <Grid container>
          <Grid item md={4}>
            <TextFieldElement
              name="publishDelayMs"
              label={$t({
                id: 'socialExport.form.publishDelay',
                defaultMessage: 'Retraso de publicación (ms)',
              })}
              type="number"
              fullWidth
              inputProps={{
                min: 0,
                max: 60000,
                step: 1,
              }}
              helperText={$t({
                id: 'socialExport.form.publishDelayHelper',
                defaultMessage:
                  'Tiempo de espera antes de publicar (0-60000 ms, por defecto: 10000)',
              })}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item md={4}>
            <TextFieldElement
              name="deleteDelayMs"
              label={$t({
                id: 'socialExport.form.deleteDelay',
                defaultMessage: 'Retraso de eliminación (ms)',
              })}
              type="number"
              fullWidth
              inputProps={{
                min: 0,
                max: 60000,
                step: 1,
              }}
              helperText={$t({
                id: 'socialExport.form.deleteDelayHelper',
                defaultMessage:
                  'Tiempo de espera antes de eliminar (0-60000 ms, por defecto: 2000)',
              })}
            />
          </Grid>
        </Grid>
      </FormSection>
      <FormActionsMui cancel />
    </FormContainer>
  );
}
